import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import { useEffect, useState } from "react";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";
import { useParams } from "react-router-dom";
import DocumentsTable from "@mirage/components/documentsTable/DocumentsTable";
import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import ENoticeSummaryTab from "./ENoticeSummaryTab";
import EnforcementNoticeTabs, { ENoticeTabs } from "./EnforcementNoticeTabs";
import { IEnforcementNoticeDetails } from "@shared/publicportal/contracts/IEnforcementNoticeDetails";
import EnforcementService from "@publicPortal/services/EnforcementNoticeService";
import { ENoticeMapTab } from "./ENoticeMapTab";
import { atom, useRecoilState } from "recoil";

const enforcementNoticeDetailsState = atom({
    key: "enforcementNoticeDetailsState",
    default: {} as { [x: string]: ENoticeTabs },
});

const EnforcementNotice = () => {
    const enforcementService = new EnforcementService();
    const { noticeId } = useParams();
    const [currentTab, setCurrentTab] = useRecoilState(enforcementNoticeDetailsState);
    const [notice, setNotice] = useState<IEnforcementNoticeDetails | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getNotice();
    }, []);

    return (
        <>
            <ResponsiveAppBar />
            <Board headerText={"Enforcement Notice " + (notice?.name || " not found")} size="big" loadingHeaderText={loading}>
                <BackButton />
                {getBoardContent()}
            </Board>
        </>
    );

    function getBoardContent() {
        if (notice?.id) {
            return (
                <>
                    <EnforcementNoticeTabs
                        cardName={currentTab[notice.id] || "Summary"}
                        handleChangeTab={(newTab) => {
                            setCurrentTab((prev) => ({ ...prev, [notice.id]: newTab }));
                        }}
                    />
                    {getContentForTab(notice)}
                </>
            );
        }
    }

    function getContentForTab(notice: IEnforcementNoticeDetails) {
        switch (currentTab[notice.id] || "Summary") {
            case RecordDetailsTabNames.Summary:
                return <ENoticeSummaryTab notice={notice} loading={loading} />;
            case RecordDetailsTabNames.Documents:
                return (
                    <DocumentsTable
                        publicOnly={true}
                        readOnly
                        stateKey="enforcement-notice-documents"
                        displayFor={{ entityRecord: { entityName: "E_NOTICE", recordId: Number(noticeId) } }}
                    />
                );
            case RecordDetailsTabNames.Map:
                return <ENoticeMapTab notice={notice} />;
            default:
                return null;
        }
    }

    async function getNotice() {
        setLoading(true);

        const response = noticeId && (await enforcementService.getEnforcementById(Number(noticeId)));
        if (!response) {
            setLoading(false);
            return;
        }
        setNotice(response);
        setLoading(false);
    }
};

export default EnforcementNotice;
